module.exports = __webpack_public_path__ + "img/icon03.b6681a4.png";